import React, { useEffect } from 'react';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { Page } from '../../components/atoms/layout/Page';
import { PageBody } from '../../components/atoms/layout/PageBody';
import { observer, useLocalStore } from 'mobx-react';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { PagedList } from '../../../admin/types/pagination';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import './lessonHomeWorkSubmissionListPage.module.scss';
import { CourseWorkSubmissionPlaceholder } from '../../components/molecules/course_work_submissions/CourseWorkSubmissionPlaceholder';
import { Pager } from '../../../commonv3/components/organisms/tables/Pager';
import { LessonHomeWorkSubmissionListState } from './states/LessonHomeWorkSubmissionListState';
import { LessonHomeworkId } from '../../../commonv3/types/lesson_homeworks';
import { LessonHomeworkSubmissionForOthersListItem } from '../../components/organisms/lesson_homeworks/LessonHomeworkSubmissionForOthersListItem';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

type Props = {
  match: {
    params: {
      lessonHomeWorkId: LessonHomeworkId;
    };
  };
};

export const LessonHomeWorkSubmissionListPage = observer(
  ({
    match: {
      params: { lessonHomeWorkId },
    },
  }: Props) => {
    useNavigation(NavigationSpecs.side());
    const { pageState } = useLocalStore(() => ({
      pageState: new LessonHomeWorkSubmissionListState(),
    }));
    useEffect(() => {
      pageState.init(lessonHomeWorkId);
    }, [lessonHomeWorkId]);
    if (pageState.submissions.loading) {
      return <LoaderRow />;
    }
    const submissionList = pageState.submissions.getOrElse(PagedList.empty());
    const breadCrumbItems = [{ text: '課題' }];
    return (
      <Page id="user-course-work-submission-list-page">
        <BreadCrumb items={breadCrumbItems} hasHome />
        <PageHeader title="HOMEWORK" />
        <LessonHomeWorkSubmissionList submissionList={submissionList} setPage={pageState.setPage} />
      </Page>
    );
  }
);

export const LessonHomeWorkSubmissionList = ({ submissionList, setPage }) => {
  const submissions = submissionList.entries;
  return (
    <PageBody styleName="body">
      {submissions.length === 0 && (
        <CourseWorkSubmissionPlaceholder>提出された課題はありません</CourseWorkSubmissionPlaceholder>
      )}
      {submissions.map((submission) => {
        return <LessonHomeworkSubmissionForOthersListItem key={submission.token} submission={submission} />;
      })}
      <Pager list={submissionList} onPageUpdate={setPage} />
    </PageBody>
  );
};
